(() => {
  const key = 'dawn-wishlist';
  const get = () => { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (_) { return []; } };
  const set = (items) => { localStorage.setItem(key, JSON.stringify(items)); document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: items })); };
  const toggle = (handle) => { const items = get(); const index = items.indexOf(handle); index === -1 ? items.push(handle) : items.splice(index, 1); set(items); return index === -1; };
  const update = () => {
    const items = get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = items.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', active);
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${button.dataset.productHandle} ${active ? 'from' : 'to'} wishlist`);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => { count.textContent = items.length; count.classList.toggle('is-visible', items.length > 0); });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation(); toggle(button.dataset.productHandle); update();
  });
  document.addEventListener('wishlist:changed', update);
  document.addEventListener('DOMContentLoaded', update);

  document.addEventListener('change', (event) => {
    const swatch = event.target.closest('[data-showcase-swatch]');
    if (!swatch) return;
    const card = swatch.closest('[data-showcase-card]');
    const option = swatch.options[swatch.selectedIndex];
    const variantInput = card.querySelector('[name="id"]');
    if (variantInput) variantInput.value = option.value;
    card.querySelector('[data-showcase-price]').innerHTML = option.dataset.price;
    if (option.dataset.image) card.querySelector('[data-showcase-image]').src = option.dataset.image;
    if (swatch.dataset.redirect === 'true') window.location.href = card.dataset.productUrl + '?variant=' + option.value;
  });

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-showcase-variant]');
    if (!choice) return;
    const card = choice.closest('[data-showcase-card]');
    const variantInput = card.querySelector('[name="id"]');
    if (variantInput) variantInput.value = choice.dataset.variantId;
    card.querySelector('[data-showcase-price]').textContent = choice.dataset.variantPrice;
    if (choice.dataset.variantImage) card.querySelector('[data-showcase-image]').src = choice.dataset.variantImage;
    card.querySelectorAll('[data-showcase-variant]').forEach((item) => item.classList.toggle('is-selected', item === choice));
    if (choice.dataset.redirect === 'true') window.location.href = choice.dataset.variantUrl;
  });

  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-showcase-cart-behavior="cart"]')) event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-wishlist-add-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button.disabled = true;
    const behavior = form.dataset.cartBehavior || 'drawer';
    try {
      if (behavior === 'cart') { form.submit(); return; }
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const data = new FormData(form);
      if (cart) { data.append('sections', cart.getSectionsToRender().map((section) => section.id)); data.append('sections_url', window.location.pathname); }
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = data;
      const response = await fetch(window.routes.cart_add_url, config);
      const result = await response.json();
      if (result.status) throw new Error(result.description || 'Unable to add this product');
      if (cart && cart.tagName === "CART-DRAWER") {
        const sectionUrls = [
          window.routes.cart_url + "?section_id=cart-drawer",
          window.routes.cart_url + "?section_id=cart-icon-bubble",
        ];
        const sectionResponses = await Promise.all(sectionUrls.map((url) => fetch(url, { credentials: "same-origin" })));
        const sectionHtml = await Promise.all(sectionResponses.map((response) => response.text()));
        cart.setActiveElement?.(button);
        cart.renderContents({
          id: result.id,
          sections: { "cart-drawer": sectionHtml[0], "cart-icon-bubble": sectionHtml[1] },
        });
      } else if (cart) {
        cart.setActiveElement?.(button);
        cart.renderContents(result);
      } else {
        window.location.href = window.routes.cart_url;
      }
    } catch (error) { alert(error.message); } finally { button.disabled = false; }
  });
})();
